export default {"src":"/_next/static/media/vivo_logo.ae88b0a5.svg","height":428,"width":1200};